module.exports = __webpack_public_path__ + "static/media/Map.a442c0b2.jpg";